<template>
  <div class="columns is-multiline">
    <div class="column is-1">
      <div class="is-position-relative height-100px">
        <img
          :src="logoDemande ? logoDemande : '/static/img/default-placeholder.png'"
          class="image logo-img" alt="Logo"/>
      </div>
    </div>
    <div class="column is-6">
      <div class="columns is-multiline">
        <div class="column is-12 pdb-0">
          <div class="has-text-weight-bold is-size-5 columns">
            <div class="column is-narrow pdr-0">
              {{ $t('addEditOrdreTravailTech.demandeLiee.info.code') }}
            </div>
            <router-link-blank :to="{ name: 'c.logistique.demande_intervention',
        params: { id: demandeIntervention.id } }"
                               class="column is-narrow pdl-0"
                               :message="demandeIntervention.code"
                               typeIcon="is-primary" sizeIcon="is-small">
            </router-link-blank>
          </div>
        </div>
        <div class="column is-12 pdv-0 is-size-7 has-text-default">
          {{ $t('addEditOrdreTravailTech.demandeLiee.info.send') }}
          {{ demandeIntervention.creationTime | formatDate }}
        </div>
        <div class="column is-12 has-text-weight-bold has-text-default pdb-0">
          {{ $t('addEditOrdreTravailTech.demandeLiee.info.description') }}
        </div>
        <div class="column is-12 pdt-0 has-text-default">
          {{ demandeIntervention.actionLogistique }}
        </div>
      </div>
    </div>
    <div class="column is-3 mgv-auto">
      <div class="columns is-multiline">
        <div class="column is-narrow pdr-0">
          <figure class="media-left">
            <avatar :size="48"
                    :src="logoDemandeur"
                    :username="getUserName">
            </avatar>
          </figure>
        </div>
        <div class="column is-8 pdl-0 has-text-weight-bold has-text-link mgv-auto">
          {{ getUserName }}
        </div>
      </div>
    </div>
    <div class="column is-2 has-text-right mgv-auto" v-if="!isDetail">
      <a @click="$emit('deleteDemande', demandeIntervention.id)">
        <b-icon icon="delete-forever" type="is-danger">
        </b-icon>
      </a>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import Avatar from 'vue-avatar';
import getLogo from '@/services/general/getLogo';
import messageErreur from '@/services/general/messageErreur';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import intToGuid from '@/services/general/transformIntToGuid';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    ot: {
      type: Object,
      required: true,
    },
    demandeIntervention: {
      type: Object,
      required: true,
    },
    isDetail: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      logoDemande: null,
      logoDemandeur: null,
    };
  },
  components: {
    routerLinkBlank,
    Avatar,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    getUserName() {
      const userFind = this.parametre(PARAMETRES_KEYS.utilisateur).find((user) => {
        return user.id === this.demandeIntervention.demandeurId;
      });
      return userFind ? userFind.decorator.nomPrenom : '';
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
      this.logoDemande = await getLogo(this.demandeIntervention.id);
      if (this.demandeIntervention.demandeurId) {
        this.logoDemandeur = await getLogo(intToGuid(this.demandeIntervention.demandeurId));
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
